export default __webpack_public_path__ + "static/media/walkCool.a9839d89.gif";